function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import functions from '@paperstac/firebase/lib/functions';
import { getPerformance } from '@paperstac/firebase/lib/performance';
export default /*#__PURE__*/(function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
    var action, payload, trace, serverDispatch, response;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            action = _ref.action, payload = _ref.payload;
            trace = getPerformance().trace('serverDispatch');
            trace.putAttribute('action', action);
            trace.start();
            serverDispatch = functions.httpsCallable('serverDispatch');
            _context.next = 7;
            return serverDispatch({
              action: action,
              payload: payload
            });
          case 7:
            response = _context.sent;
            trace.stop();
            return _context.abrupt("return", response);
          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref2.apply(this, arguments);
  };
})();